import Nullstack from 'nullstack';
export default function IconHeadphones({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-headphones",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "4",
    y: "13",
    rx: "2",
    width: "5",
    height: "7"
  }), "   ", Nullstack.element("rect", {
    x: "15",
    y: "13",
    rx: "2",
    width: "5",
    height: "7"
  }), "   ", Nullstack.element("path", {
    d: "M4 15v-3a8 8 0 0 1 16 0v3"
  }), " ");
}